import { RouteEnum } from '../../constants/routes.enum'

export const ProjectRequiredSections = [RouteEnum.WORKSPACE.replace('/', ''), RouteEnum.OBJECTS.replace('/', '')]

export enum LoadState {
  Loading = 'loading',
  Loaded = 'loaded',
}
